<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 hidden-sm-and-up>
        <v-select
          :items="categories"
          v-model="categorySelect"
          label="Categoría"
          outline
          @change="changeCategory(categorySelect)"
        ></v-select>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex sm2 pt-5 hidden-xs-only>
        <v-btn
          v-for="(type, idx) in categories"
          :key="idx"
          block
          flat
          class="btn-white-security text-14-security"
          :style="type == selectedCategory ? 'background: #789c4a !important; border-color: #789c4a !important; color: white; font-weight: 700;': '' "
          @click="changeCategory(type)"
          :id="type"
        >{{ type }}</v-btn>
      </v-flex>
      <v-flex xs12 :class="{'sm10 pl-4': $vuetify.breakpoint.smAndUp}">
        <v-flex xs12 sm12>
          <book-infinite :category="selectedCategory" :key="selectedCategory" url="/library"/>
        </v-flex>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import BookInfinite from "./BookInfinite"
import { mapActions, mapState } from 'vuex';
export default {
  data(){
    return {
      selectedCategory: this.category,
      categorySelect: "todos",
    }
  },
  components: {
    BookInfinite
  },
  props: {
    filterCategory: {
      type: String,
      required: false
    },
    category: {
      type: String,
      required: true
    },
    categories: {
      type: Array,
      required: true
    }
  },
  methods: {
    changeCategory(cat) {
      this.selectedCategory = cat;
    }
  },
  beforeMount() {
    
    let param = this.$route.params.category
    if ( param && param.length)
      this.category = param
  }
}
</script>

<style>

</style>